import React from "react";
import { Link } from "gatsby";
import { Overlay } from "./OverlayMenu.styles";
import { useMenuQuery } from "../../hooks/useMenuQuery"

const OverlayMenu = ({menuOpen, callback}) => {

    const { wpMenu } = useMenuQuery();

    return(
        <Overlay menuOpen={menuOpen}>
            <div>
                <ul className="menu">
                    {wpMenu.menuItems.nodes.map(mainItem=>(
                        !mainItem.parentId
                          ?(
                            <li key={mainItem.id}>
                            {
                                mainItem.target !== null
                                    ?(
                                        <a href={mainItem.url} target={mainItem.target} className={mainItem.cssClasses.join(' ')}>
                                            {mainItem.label}
                                        </a>
                                    )

                                    :(
                                        <Link to={mainItem.url} activeClassName="active">
                                            <span className="text">{mainItem.label}</span>
                                        </Link>
                                    )
                                }

                                {mainItem.childItems.nodes.length !== 0 ? (
                                    <ul>
                                        {mainItem.childItems.nodes.map(childItem => (
                                            <li key={childItem.id}>
                                                <Link to={childItem.url} activeClassName="active">
                                                    <span className="text">{childItem.label}</span>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                ) : null }
                            </li>
                          )
                          : null
                    ))}
                </ul>
            </div>
        </Overlay>
    )
}

export default OverlayMenu